import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";

import { Box, Typography } from "@mui/material";

import { Modal } from "./Modal/Modal";

const useStyles = makeStyles()((theme) => ({
    container: {
        backgroundColor: theme.palette.emteria.background.paperDeep,
        padding: theme.spacing(6),
        borderRadius: 1,
        overflow: "auto",
    },
}));

interface ConfigDialogProps {
    open: boolean;
    configData: object | null;
    onClose: () => void;
}

const ConfigDialog: React.FC<ConfigDialogProps> = ({ open, configData, onClose }) => {
    const { classes } = useStyles();
    const { t } = useTranslation(["modals"]);

    return (
        <Modal open={open} onClose={onClose} title={t("modals:buildConfig.title")}>
            {configData ? (
                <Box component="pre" className={classes.container}>
                    {JSON.stringify(configData, null, 2)}
                </Box>
            ) : (
                <Typography variant="body1">{t("modals:buildConfig.noBuildConfig")}</Typography>
            )}
        </Modal>
    );
};

export default ConfigDialog;
